import { createSlice } from "@reduxjs/toolkit";

const luckyDrawOptimSlice = createSlice({
  name: "luckyDrawOptim",
  initialState: {
    loading: false,
    saving: false,
    luckyDrawData: [],
    total: 0,
    error: null,
  },

  reducers: {
    saveLuckyDrawOptimRequest: (state) => {
      state.saving = true;
    },

    saveLuckyDrawOptimSuccess: (state) => {
      state.saving = false;
    },

    saveLuckyDrawOptimFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },

    getLuckyDrawOptimsRequest: (state) => {
      state.loading = true;
    },

    getLuckyDrawOptimsSuccess: (state, action) => {
      state.loading = false;
      state.luckyDrawData = action?.payload?.data?.data || [];
      state.total = action?.payload?.data?.total || 0;
    },

    getLuckyDrawOptimsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateLuckyDrawOptimStatusRequest: (state) => {
      state.loading = true;
    },

    updateLuckyDrawOptimStatusSuccess: (state, action) => {
      state.loading = false;
      const updated = action.payload;
      state.luckyDrawData = state.luckyDrawData.map((item) =>
        item._id === updated?._id ? { ...item, ...updated } : item,
      );
    },

    updateLuckyDrawOptimStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  saveLuckyDrawOptimRequest,
  saveLuckyDrawOptimSuccess,
  saveLuckyDrawOptimFailure,
  getLuckyDrawOptimsRequest,
  getLuckyDrawOptimsSuccess,
  getLuckyDrawOptimsFailure,
  updateLuckyDrawOptimStatusRequest,
  updateLuckyDrawOptimStatusSuccess,
  updateLuckyDrawOptimStatusFailure,
} = luckyDrawOptimSlice.actions;

export default luckyDrawOptimSlice.reducer;
